import { DefaultSeo } from 'next-seo';
import { NextWebVitalsMetric } from 'next/app';
import { GlobalStyle } from '@styles/global-styles';
import Head from 'next/head';
import { ResponsiveGlobal } from '@styles/responsive';
import React, { useCallback, useEffect, useState } from 'react';
import { Provider } from 'react-redux';
import { isServer, onDisabledReactDevtoolOnProduction } from '@utils/helper';
import { AppProps } from 'next/app';
import { ConfigProvider } from 'antd';
import { defaultTheme } from '@ant-design/compatible';

import 'leaflet/dist/leaflet.css';
import 'leaflet-defaulticon-compatibility/dist/leaflet-defaulticon-compatibility.webpack.css';
import '../styles/tailwind.css';
// import '../../scripts/wdyr.js';
// import { TailwindDevIndicator } from '@components/TailwindDevIndicator';

import { wrapper } from '../store';

const MyApp: React.FunctionComponent<AppProps> = ({
  Component,
  ...rest
}: AppProps) => {
  const [isLoadStaticText, setIsLoadStaticText] = useState(true);
  const { store, props } = wrapper.useWrappedStore(rest);

  const onGetStaticTextsMultiLanguage = useCallback(async () => {
    setIsLoadStaticText(false);
    const listTextLanguagesJson = await fetch(
      `${process.env.NEXT_PUBLIC_SUBFOLDER}/multilanguages.json`,
    );
    const listTextLanguages: any = await listTextLanguagesJson.json();
    window.languages = listTextLanguages;
    setIsLoadStaticText(true);
  }, []);

  useEffect(() => {
    onDisabledReactDevtoolOnProduction();
    !isServer ? onGetStaticTextsMultiLanguage() : setIsLoadStaticText(true);
  }, [onGetStaticTextsMultiLanguage]);

  return (
    <>
      <Head>
        <meta
          name="viewport"
          content="minimum-scale=1, initial-scale=1, width=device-width, shrink-to-fit=no, user-scalable=no, viewport-fit=cover"
        />
      </Head>
      <DefaultSeo
        // title="Panoee | The Smart Virtual Tour Software for everyone"
        // description="Start free to build high-quanlity & smart 360° Virtual Tour in minutes with beautiful themes & unlimited customization."
        // openGraph={{
        //   type: 'website',
        //   locale: 'en_IE',
        //   url: router.pathname,
        //   site_name: 'Panoee',
        //   title: 'Panoee | The Smart Virtual Tour Software for everyone',
        //   description:
        //     'Start free to build high-quanlity & smart 360° Virtual Tour in minutes with beautiful themes & unlimited customization.',
        // }}
        additionalMetaTags={[
          {
            property: 'category',
            content: 'Virtual Tour Software',
          },
        ]}
      />
      <Provider store={store}>
        <ConfigProvider
          theme={{
            ...defaultTheme,
            hashed: false,
            token: {
              colorPrimary: '#D1005C',
              borderRadius: 2,
              colorLink: '#007AFF',
            },
            cssVar: true,
          }}
        >
          {isLoadStaticText && <Component {...props.pageProps} />}
        </ConfigProvider>
      </Provider>
      <GlobalStyle />
      <ResponsiveGlobal />
      {/* <TailwindDevIndicator /> */}
    </>
  );
};

export function reportWebVitals({
  id,
  name,
  // startTime,
  value,
  label,
}: NextWebVitalsMetric) {
  if ((window as any).gtag)
    (window as any).gtag('send', 'event', {
      eventCategory:
        label === 'web-vital' ? 'Web Vitals' : 'Next.js custom metric',
      eventAction: name,
      eventValue: Math.round(name === 'CLS' ? value / 1000 : value), // values must be integers
      eventLabel: id, // id unique to current page load
      nonInteraction: true, // avoids affecting bounce rate.
    });
}

export default MyApp;
